import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import { FallbackScreen } from '../screens/FallbackScreen'
import { ENABLE_JIOPAY_FOR_CONSUMER, isJiopayBizzEnable } from '../util/util'
import { ContactUsSectionStack } from './ContactUsSection'
import { HomeLandingStack } from './HomeLandingSection'
import { JioBizzSectionStack } from './JioBizzSection'
import { JioPayForConsumersStack } from './JioPayForConsumersStack'
import { Linking } from './Linking'
import { navigationRef } from './NavService'
import { ProductSectionStack } from './ProductSection'
import WhyJioSectionStack from './WhyJioSection'

const { REACT_APP_CHATBOT_URL } = process.env
const Stack = createStackNavigator()
const AppStack = () => {
  // const embedChatBot = () => {
  //   const script = document.createElement('script')
  //   script.id = 'chatBotScript'
  //   script.src = REACT_APP_CHATBOT_URL
  //   document.head.appendChild(script)
  // }
  // React.useEffect(() => {
  //   embedChatBot()
  // }, [])
  return (
    <React.Suspense fallback={<FallbackScreen />}>
      <NavigationContainer ref={navigationRef} linking={Linking} independent={true}>
        <Stack.Navigator initialRouteName="jiopay" screenOptions={{ headerShown: false }}>
          {WhyJioSectionStack()}
          {ProductSectionStack()}
          {ContactUsSectionStack()}
          {HomeLandingStack()}
          {isJiopayBizzEnable ? JioBizzSectionStack() : undefined}
          {ENABLE_JIOPAY_FOR_CONSUMER && JioPayForConsumersStack()}
        </Stack.Navigator>
      </NavigationContainer>
    </React.Suspense>
  )
}

export { AppStack }
